import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { checkValues, genderSelection } from '../helpers/actions';
import { mapFormGender, UNKNOWN } from '../config';
import type {
    TSelectHandler,
    TFocusHandler,
    TChangeHandler,
    TUpdateGender,
    TRadioTags,
    TCheckbox,
} from '../models';
import { defaultHandler } from '../field/config';

import { FormActionsBase } from './base';

export class WithGender extends FormActionsBase {
    /* При изменении гендера одного из полей пересмотреть общий гендер */
    updateGender: TUpdateGender = arg => {
        const { analytics, fields, state } = this;
        const { gender } = fields;
        const genderValue = gender?.input?.value || UNKNOWN;

        const selectGender = (value: string) => {
            if (analytics && analytics.gender) {
                sendEvent(analytics.gender);
            }
            const onChange = gender ? gender.input?.onChange : defaultHandler;

            onChange(value);
            const onBlur = gender ? gender.input?.onBlur : defaultHandler;

            onBlur();
        };
        const selectedGender = genderSelection({
            ...state.gender,
            ...arg,
        });

        // устанавливаем значение поля gender
        if (selectedGender) {
            if (genderValue !== selectedGender) {
                selectGender(selectedGender);
            }
            // при невыполнении условий сбрасываем значение
        } else if (genderValue) {
            selectGender('');
        }
    };

    onSelectHandler: TSelectHandler = field => event => {
        const { gender: newGender = UNKNOWN } = event;
        const mappedGender = mapFormGender[newGender];
        const { setState, state } = this;
        const { supposeGender } = state;

        // Если пол не соответствует текущему - изменить
        if (state.gender[field] !== mappedGender) {
            this.updateGender({ [field]: mappedGender });
            setState('gender', field, mappedGender);
        }
        // Если не предустановлен пол подсказок - установить
        if (!supposeGender || supposeGender === UNKNOWN) {
            setState('supposeGender', newGender);
        }
        super.onSelectHandler(field)(event);
    };

    onBlurHandler: TFocusHandler = field => event => {
        super.onBlurHandler.call(this, field)(event);
        const { setState, state } = this;
        const { value } = this.fields[field].input;
        const { supposeGender } = state;
        const options = state.options[field];

        const genderOption = options.find(val => val.label === value)?.gender || UNKNOWN;
        const mappedGender = mapFormGender[genderOption];

        // Перерасчитать пол
        if (state.gender[field] !== mappedGender) {
            this.updateGender({ [field]: mappedGender });
            setState('gender', field, mappedGender);
        }
        // Если обнулен - проставить новый
        if (!supposeGender || supposeGender === UNKNOWN) {
            setState('supposeGender', genderOption);
        }
    };

    onCheckbox: TCheckbox = ({ checked }) => {
        const { analytics, cb, fields, middleNameRef, setState } = this;
        const value = checked ? '-' : '';

        //  Изменить в местном состоянии
        setState('hasMiddleName', !checked);
        // Если значение заменяется прочерком - изменить сразу
        if (checked) {
            fields.middleName.input.onChange(value);
            fields.middleName.input.onBlur();
            cb.onComplete(fields.middleName);
            // иначе - после обновления вернуться к отчеству и изменить
        } else {
            setTimeout(() => {
                fields.middleName.input.onFocus();
                if (middleNameRef.current) middleNameRef.current.focus();
                fields.middleName.input.onChange(value);
            }, 0);
        }

        if (analytics?.hasMiddleName) sendEvent(analytics?.hasMiddleName);
    };

    onRadioTags: TRadioTags = event => {
        const {
            analytics = {},
            fields: { gender },
        } = this;
        const genderValue = event.value;

        if (analytics.gender) sendEvent(analytics.gender);
        // Изменить поле в форме и состоянии
        gender?.input.onChange(genderValue);
        gender?.input.onBlur();
    };

    onChangeHandler: TChangeHandler = field => event => {
        const { value } = event;

        // Если пол неизвестен - обнулить
        if (!value && !checkValues(field, this.fields)) {
            this.setState('supposeGender', UNKNOWN);
        }
        super.onChangeHandler(field)(event);
    };
}
